import React, { useState, useEffect } from "react";
import icons from "../../../assets/images/constantIcons";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";

const CategoryManage = ({ isOpen, onClose }) => {
  const [dataList, setDataList] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [partyName, setPartyName] = useState("");
  const [partyType, setPartyType] = useState("customer");

  const fetchData = async () => {
    try {
      const res = await apiService.get("/parties");
      setDataList(res.data || []);
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    if (isOpen) fetchData();
  }, [isOpen]);

  const handleAddItem = async () => {
    try {
      const existingNames = dataList.map(item => item.name.toLowerCase().trim());
      const newName = partyName.trim().toLowerCase();

      if (!newName) {
        toast.error("Party name cannot be empty!", { duration: 1000 });
        return;
      }

      if (existingNames.includes(newName)) {
        toast.error("This party name already exists!", { duration: 1000 });
        return;
      }

      const payload = { party: { name: partyName, party_type: partyType } };
      const res = await apiService.post("/parties", payload);

      toast.success(res.message || "Party added successfully!", { duration: 2000 });

      setPartyName("");
      setPartyType("customer");

      fetchData();
    } catch (errors) {
      handleError(errors);
    }
  };

  const handleRenameItem = async () => {
    try {
      await apiService.patch(`/parties/${editingItem.id}`, { name: editingItem.name });
      toast.success("Party updated successfully", { duration: 2000 });
      setEditingItem(null);
      fetchData();
    } catch (errors) {
      handleError(errors);
    }
  };

  const handleDeleteItem = async () => {
    try {
      await apiService.delete(`/parties/${deleteItemId}`);
      toast.success("Party deleted successfully", { duration: 2000 });
      setDeleteItemId(null);
      fetchData();
    } catch (errors) {
      handleError(errors);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-G500">Manage Parties</h3>
          <icons.IoClose
            className="text-2xl text-green cursor-pointer"
            onClick={onClose}
          />
        </div>

        {/* Add New Party */}
        <div className="mb-6">
          <div>
            <label className="text-sm font-medium text-G500 mb-2 block">
              Add New Party
            </label>
            <div className="space-y-3">
              <input
                type="text"
                value={partyName}
                onChange={(e) => setPartyName(e.target.value)}
                className="inputtext"
                placeholder="Enter party name"
              />
            </div>
          </div>
          {/* <div className="flex space-x-3">
              {["customer", "supplier"].map((type) => (
                <button
                  key={type}
                  type="button"
                  className={`px-4 py-1.5 rounded-full border text-sm ${
                    partyType === type
                      ? "bg-green50 text-green border-green"
                      : "bg-white text-G400 border-G200"
                  }`}
                  onClick={() => setPartyType(type)}
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </button>
              ))}
            </div> */}
          <button
            className="bg-green text-white px-4 py-2 rounded-lg text-sm w-full mt-4"
            onClick={handleAddItem}
          >
            Add
          </button>

        </div>

        {/* Existing Parties */}
        <h4 className="text-sm font-semibold mb-3">
          Existing Parties ({dataList.length})
        </h4>
        <div className="space-y-2 max-h-[30vh] overflow-y-auto vertical">
          {dataList.length === 0 ? (
            <div className="text-center text-gray-500 py-6 text-sm">
              No parties added yet.
            </div>
          ) : (
            dataList.map((item) => (
              <div
                key={item.id}
                className="flex justify-between items-center border px-3 py-2 rounded-lg"
              >
                <span>{item.name}</span>
                <div className="flex gap-4">
                  <div
                    className="w-8 h-8 flex justify-center items-center text-base font-bold text-green cursor-pointer bg-green50 rounded-full"
                    onClick={() => setEditingItem({ ...item })}
                  >
                    <icons.FaRegEdit />
                  </div>
                  <div
                    className="w-8 h-8 flex justify-center items-center text-base font-bold bg-red bg-opacity-10 cursor-pointer text-red rounded-full"
                    onClick={() => setDeleteItemId(item.id)}
                  >
                    <icons.AiOutlineDelete />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Rename Modal */}
        {editingItem && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-80">
              <h4 className="font-semibold mb-4">Update Party</h4>
              <input
                type="text"
                value={editingItem.name}
                onChange={(e) =>
                  setEditingItem({ ...editingItem, name: e.target.value })
                }
                className="inputtext"
              />
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  className="px-4 py-2 text-sm border rounded bg-gray-100"
                  onClick={() => setEditingItem(null)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 text-sm bg-green text-white rounded"
                  onClick={handleRenameItem}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirm Modal */}
        {deleteItemId && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-80">
              <h4 className="font-semibold mb-4">
                Are you sure you want to delete this party?
              </h4>
              <div className="flex justify-end space-x-3">
                <button
                  className="px-4 py-2 text-sm border rounded bg-gray-100"
                  onClick={() => setDeleteItemId(null)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 text-sm bg-red text-white rounded"
                  onClick={handleDeleteItem}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryManage;

